import {
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    DataTableFacetOptionsProps
} from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useDataTableContext
} from "../../context";
import {
    PopoverLayoutContext
} from "../../../popover/context";
import {
    formatNumber
} from "../../../../helpers/locale";
import {
    DATA_TABLE_LISTBOX_PROPS
} from "../../util";
import OptionRow from "../../../optionRow";
import Badge from "../../../badge";

const DataTableFacetOptions: FC<DataTableFacetOptionsProps> = ({
    variant: variantProp,
    customTheme,
    columnId
}) => {
    const context = useDataTableContext({
        part: "FacetedFilter"
    });

    const layout = useContext(PopoverLayoutContext);

    const {
        activeLocale
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const column = context?.allColumns.find((item) => item.id === columnId);

    if(!context || !column?.filterOptions) {
        return null;
    }

    const variant = variantProp ?? (layout.isSheet ? "sheet" : "popover");

    const selectedValues = context.columnFilters[columnId] ?? [];

    const handleToggle = (value: string) => {
        context.handleColumnFilterChange(columnId, selectedValues.includes(value) ? selectedValues.filter((item) => item !== value) : [
            ...selectedValues,
            value
        ]);
    };

    return <View
        aria-multiselectable={true}
        aria-label={column.header}
        {...DATA_TABLE_LISTBOX_PROPS}
    >
        {
            column.filterOptions.map((option) => {
                const count = option.count ?? context.facetCounts[columnId]?.[option.value];

                return <OptionRow
                    isSelected={selectedValues.includes(option.value)}
                    onPress={() => handleToggle(option.value)}
                    trailing={
                        count === undefined ?
                            undefined
                        :
                            <Badge
                                title={formatNumber({
                                    locale: activeLocale,
                                    value: count
                                })}
                                customTheme={customTheme}
                                type="neutral"
                                size="small"
                            />
                    }
                    customTheme={customTheme}
                    label={option.label}
                    key={option.value}
                    variant={variant}
                    isMultiple={true}
                    role="option"
                    tabIndex={0}
                />;
            })
        }
    </View>;
};
export default DataTableFacetOptions;
